import { render, staticRenderFns } from "./InputNumberElement.vue?vue&type=template&id=f1854ed0&"
import script from "./InputNumberElement.vue?vue&type=script&lang=js&"
export * from "./InputNumberElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports